export const getCatalogById = (id, catalogList) => {
  
  const elementFound = catalogList.find(
    (conf) => conf.id === id
  );
  return elementFound;
};
